import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);


export function createCancelToken() {
  const {CancelToken} = axios;
  return CancelToken.source();
}


export default axiosInstance;
